
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate/[id]",
      function () {
        return require("private-next-pages/certificate/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate/[id]"])
      });
    }
  